export const GLOBAL_STATE = 'Types'
export const TYPES = 'TYPES' as const
export const TYPES_CHILD = 'TYPES_CHILD' as const
